import HomeIcon from '../images/articulos/home.svg';
import SettingsIcon from '../images/articulos/settings.svg';
import CheckCircleIcon from '../images/articulos/check_circle.svg';
import FavoriteIcon from '../images/articulos/favorite.svg';
import StarIcon from '../images/articulos/star.svg';
import BakeryDiningIcon from '../images/articulos/bakery_dining.svg';
import FastfoodIcon from '../images/articulos/fastfood.svg';
import CoffeeIcon from '../images/articulos/coffee.svg';
import LocalBarIcon from '../images/articulos/local_ba.svg';
import LocalPizzaIcon from '../images/articulos/local_pizza.svg';
import IcecreamIcon from '../images/articulos/icecream.svg';
import SoupKitchenIcon from '../images/articulos/soup_kitchen.svg';
import LiquorIcon from '../images/articulos/liquor.svg';
import SetMealIcon from '../images/articulos/set_meal.svg';
import LocalDiningIcon from '../images/articulos/local_dining.svg';
import DirectionsCarIcon from '../images/articulos/directions_car.svg';
import BlenderIcon from '../images/articulos/blender.svg';
import WorkspacePremiumIcon from '../images/articulos/workspace_premium.svg';
import HelpIcon from '../images/articulos/help.svg';
import DinnerDiningIcon from '../images/articulos/dinner_dining.svg';
import FoodBankIcon from '../images/articulos/food_bank.svg';
import LunchDiningIcon from '../images/articulos/lunch_dining.svg';
import RestaurantIcon from '../images/articulos/restaurant.svg';
import RestaurantMenuIcon from '../images/articulos/restaurant_menu.svg';
import SportsBarIcon from '../images/articulos/sports_bar.svg';
import VerifiedIcon from '../images/articulos/verified.svg';
import CookieIcon from '../images/articulos/cookie.svg';

const icons = {
  HomeIcon,
  SettingsIcon,
  CheckCircleIcon,
  FavoriteIcon,
  StarIcon,
  BakeryDiningIcon,
  FastfoodIcon,
  CoffeeIcon,
  LocalBarIcon,
  LocalPizzaIcon,
  IcecreamIcon,
  SoupKitchenIcon,
  LiquorIcon,
  SetMealIcon,
  LocalDiningIcon,
  DirectionsCarIcon,
  BlenderIcon,
  WorkspacePremiumIcon,
  HelpIcon,
  DinnerDiningIcon,
  FoodBankIcon,
  LunchDiningIcon,
  RestaurantIcon,
  RestaurantMenuIcon,
  SportsBarIcon,
  VerifiedIcon,
  CookieIcon,
};

export default icons;